<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">发货单详情</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button style="margin-right: 10px" @click="$router.go(-1)">返回</form-button>
        <btky-header
          :form-data="wlyApplyForGoodsPo"
          :process-key="processKey"
          @formDataSave="validate(saveData)"
          @validate="validate"
        />
      </div>
      <el-form ref="form" :show-message="false" inline size="mini" label-width="100px" :model="wlyApplyForGoodsPo" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="要货单号">
              <el-input
                v-model="wlyApplyForGoodsPo.wantCode"
                placeholder="自动生成"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单客户">
              <el-input v-model="wlyApplyForGoodsPo.customerName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input
                v-model="wlyApplyForGoodsPo.billCustomer"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="planType">
              <el-select v-model="wlyApplyForGoodsPo.planType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制单票据类型">
              <el-select v-model="wlyApplyForGoodsPo.noticeSheetType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销中心">
              <el-select
                v-model="wlyApplyForGoodsPo.saleCenter"
                placeholder="请选择"
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额年度" prop="quotasYear">
              <el-input :value="wlyApplyForGoodsPo.quotasYear" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 取经销商该年度签署合同渠道、如果不是配额计划，渠道为空 -->
          <el-col :lg="8" :md="12">
            <el-form-item prop="channelsType" label="渠道类型">
              <el-select v-model="wlyApplyForGoodsPo.channelsType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0054']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="紧急程度" prop="significance">
              <el-select v-model="wlyApplyForGoodsPo.significance" disabled>
                <el-option
                  v-for="item in selectDataOptions['Significance']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否瓶储" prop="isPcj">
              <el-select v-model="wlyApplyForGoodsPo.isPcj" disabled>
                <el-option :value="0" label="否" />
                <el-option :value="1" label="是" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isPcj == 1" :lg="8" :md="12">
            <el-form-item label="瓶储截止日期">
              <el-date-picker
                v-model="wlyApplyForGoodsPo.saveEnddate"
                disabled
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isCxj">
            <el-form-item label="是否存新酒" prop="isCxj">
              <el-select v-model="wlyApplyForGoodsPo.isCxj" disabled>
                <el-option
                  v-for="item in selectDataOptions['B0099']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isCxj == 1" :lg="8" :md="12">
            <el-form-item
              label="储存期限(月)"
              :required="wlyApplyForGoodsPo.isCxj == 1 ? true : false"
            >
              <el-input
                v-model="wlyApplyForGoodsPo.savedMonths"
                placeholder="请输入"
                type="text"
                clearable
                :disabled="wlyApplyForGoodsPo.subProcUnitId !== 'work'"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isZdzg">
            <el-form-item label="要货单类型" prop="demandType">
              <el-select v-model="wlyApplyForGoodsPo.demandType" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0081']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isZdzg">
            <el-form-item label="收货终端" prop="terminalName">
              <wly-input
                v-model="wlyApplyForGoodsPo.terminalName"
                input-type="terminal"
                disabled
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="8" :md="12" v-if="isZdzg">
            <el-form-item label="跳转" prop="terminalName">
              <div class="panorama" @click="jumpPanorama">终端全景</div>
            </el-form-item>
          </el-col> -->
        </el-row>
        <div class="table-container" style="padding: 0">
          <TableCommon title="要货明细" :custome-config="() => vxeShowCustom('xTable')">
            <vxe-grid
              ref="xTable"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="300"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions.columns"
              :data="gridOptions.data"
            >
              <!-- <template #toolbar /> -->
              <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
                <div :key="item.field">
                  <el-input
                    v-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        wlyApplyForGoodsPo.subProcUnitId === '' &&
                        item.field === 'wantQuantity'
                    "
                    v-model.number="row[item.field]"
                    size="mini"
                    :disabled="isZdzg"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'baseAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'base'
                    "
                    v-model.number="row[item.field]"
                    size="mini"
                    :disabled="isZdzg"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'warAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'warZone'
                    "
                    v-model.number="row[item.field]"
                    size="mini"
                    :disabled="isZdzg"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'salecenterAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'work'
                    "
                    v-model.number="row[item.field]"
                    size="mini"
                    :disabled="isZdzg"
                  />

                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'remark'
                    "
                    v-model="row[item.field]"
                    size="mini"
                  />
                  <span v-else-if="item.field === 'inventoryRate'">{{
                    handleRate(row)
                  }}</span>
                  <span v-else-if="item.field === 'brandBq'">{{
                    filterDictionary(row.brandBq, 'A0019')
                  }}</span>
                  <span v-else>{{ row[item.field] }}</span>
                </div>
              </template>
            </vxe-grid>
          </TableCommon>

          <TableCommon title="近三次要货数据" :custome-config="() => vxeShowCustom('xTable')">
            <vxe-grid
              ref="xTable"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="300"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions4.columns"
              :data="gridOptions4.data"
            >
            </vxe-grid>
          </TableCommon>

          <TableCommon
            title="占用发票明细"
            :custome-config="() => vxeShowCustom('xTable2')"
          >
            <vxe-grid
              ref="xTable2"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="240"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions3.columns"
              :data="gridOptions3.data"
            >
              <!-- <template #toolbar /> -->
              <template v-for="item in gridOptions3.columns" #[item.field]="{ row }">
                <div :key="item.field">
                  <el-input
                    v-if="gridOptions3.columnsFieldTypes[item.field] == 'input'"
                    v-model="row[item.field]"
                    size="mini"
                  />
                  <span v-else>{{ row[item.field] }}</span>
                </div>
              </template>
            </vxe-grid>
          </TableCommon>

          <common-title title="收货信息" />
          <el-row :gutter="24">
            <!-- 是 分流经销商 分流收货单位 必填 -->
            <el-col :lg="8" :md="12">
              <el-form-item label="是否分流：">
                <el-select v-model="wlyApplyForGoodsPo.isShunt" disabled>
                  <el-option
                    v-for="item in selectDataOptions['B0099']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 开票客户的分流经销商 -->
            <template v-if="wlyApplyForGoodsPo.isShunt === '1'">
              <el-col :lg="8" :md="12">
                <el-form-item label="分流经销商">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntDealer"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="分流渠道类型">
                  <el-select v-model="wlyApplyForGoodsPo.shuntChannelsType" disabled>
                    <el-option
                      v-for="item in selectDataOptions['A0054']"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 开票客户的分流经销商 -->
              <el-col :lg="8" :md="12">
                <el-form-item label="分流收货单位">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntReceiveUnitName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </template>
            <!-- 默认订单客户 -->
            <el-col :lg="8" :md="12">
              <el-form-item :label="wlyApplyForGoodsPo.ggtg === 1 ? '喷码内容' : '喷码单位'">
                <el-input
                  v-model="wlyApplyForGoodsPo.spurtCodeUnitName"
                  disabled
                />
              </el-form-item>
            </el-col>
            <!-- 客户的收货地址 -->
            <el-col :lg="8" :md="12">
              <el-form-item :label="isZdzg ? '收货终端' :'收货单位'" prop="receiveUnitName">
                <el-input
                  v-model="wlyApplyForGoodsPo.receiveUnitName"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="联系电话">
                <el-input
                  v-model="wlyApplyForGoodsPo.contactNumber"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="16" :md="12">
              <el-form-item label="收货地址" prop="receiveAddress">
                <el-input
                  v-model="wlyApplyForGoodsPo.receiveAddress"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="收货联系人">
                <el-input
                  v-model="wlyApplyForGoodsPo.contacPerson"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <!-- 是 备注必填 -->
            <el-col :lg="8" :md="12" v-if="wlyApplyForGoodsPo.demandType !='ZDZG'">
              <el-form-item label="是否自提">
                <el-checkbox
                  v-model="wlyApplyForGoodsPo.selfacceptance"
                  :true-label="1"
                  :false-label="0"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="wlyApplyForGoodsPo.remark"
                  placeholder="请输入"
                  resize="none"
                  :autosize="{ minRows: 2, maxRows: 2 }"
                  type="textarea"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 渠道类型选择KA时 -->
          <common-title v-if="wlyApplyForGoodsPo.channelsType == 'K'" title="KA卖场信息" />
          <el-row v-if="wlyApplyForGoodsPo.channelsType == 'K'" :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场全称">
                <el-select
                  v-model="wlyApplyForGoodsPo.kaStoreFullname"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场简称">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreShortName" disabled />
              </el-form-item>
            </el-col>
            <!-- 订单客户所在区域 -->
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场区域">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreArea" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <TableCommon title="附件" :custome-config="() => vxeShowCustom('xTable3')">
            <vxe-grid
              ref="xTable3"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions2.columns"
              :data="gridOptions2.data"
            >
              <template #fileName="{row}">
                <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
              </template>
              <template #createdDate="{row}">
                <span>{{ row.createdDate || row.creator.createdDate }}</span>
              </template>
            </vxe-grid>
          </TableCommon>

          <purchase-footer :form-data="wlyApplyForGoodsPo" />
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { queryFiles, apiAttachmentDownFile } from '@/api/common'
import { wantgoodsFindById, findLastThreeTimesWantDetail, thirdRealTimeInventory } from '@/api/applyForGoods/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import { handlerFlow } from '@/api/flowHander'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { filterDictionary } from '@/utils/index'
import { download } from '@/utils/frontExport'

export default {
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    distributeCustList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const rules = {
      // channelsType: [{ required: true, message: '请选择渠道类型', trigger: 'change' }],
      significance: [{ required: true, message: '请选择紧急程度', trigger: 'change' }],
      receiveUnitName: [{ required: true, message: '请选择收货单位名称', trigger: 'change' }]
    }
    return {
      panoramaUrl: '',
      processKey: 'wantGoods',
      rules,
      isPcj: false,
      errorList: [],
      saleList: [],
      wlyApplyForGoodsPo: {
        id: '',
        taskId: '',
        subProcUnitId: '',
        isPcj: '0',
        bizId: '',
        status: 0,
        billCode: '',
        bizCode: 'wantGoods',
        billStatus: 'E001',
        billCustCode: '',
        billCustomer: '',
        shuntDealer: '',
        clientId: '',
        ticketDetailId: '',
        remark: '',
        customerCode: '',
        customerName: '',
        noticeSheetType: '',
        receiveUnitCode: '',
        channelsType: '',
        quotasYear: '',
        saleCenter: '', // 营销单元
        isShunt: '0',
        significance: 'normal',
        KA_store_shortName: '',
        KA_Store_FullName: '',
        ka_store_area: '',
        acceptUnitType: '',
        receiveUnitName: '',
        receiveAddress: '四川省成都市崇州市崇阳镇街道下南街259号',
        contacPerson: '周卫星',
        contactNumber: '13320966068',
        shuntChannelsType: '',
        shuntReceiveUnitCode: '',
        shuntReceiveUnitName: '',
        spurtCodeUnit: '',
        spurtCodeUnitName: '',
        selfacceptance: 0,
        ggtg: '0',
        saveEnddate: '',
        savedMonths: ''
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          {
            field: 'brandTextView',
            title: '存货分类',
            width: 100
          },
          {
            field: 'productDesc',
            title: '产品描述',
            width: 250
          },
          {
            field: 'undeliveredQuantity',
            title: '未发货量',
            width: 80
          },
          {
            field: 'wantQuantity',
            title: '本次要货量',
            width: 80,
            slots: { default: 'wantQuantity' }
          },
          {
            field: 'baseAuditQuantity',
            title: '基地协助数量',
            width: 90,
            visible: false,
            slots: { default: 'baseAuditQuantity' }
          },
          {
            field: 'warAuditQuantity',
            title: '战区协助数量',
            width: 90,
            visible: false,
            slots: { default: 'warAuditQuantity' }
          },
          {
            field: 'salecenterAuditQuantity',
            title: '销售内勤协助数量',
            width: 90,
            visible: false,
            slots: { default: 'salecenterAuditQuantity' }
          },
          {
            field: 'yearSalePlanQty',
            title: '年销售计划量',
            width: 96,
            visible: true
          },
          {
            field: 'monthSalePlanQty',
            title: '月销售计划量',
            width: 96,
            visible: true
          },
          {
            field: 'monthDeliverQty',
            title: '月累计发货',
            width: 96,
            visible: true
          },
          {
            field: 'yearDeliverQty',
            title: '年累计发货',
            width: 96,
            visible: true
          },
          {
            field: 'monthAuditQty',
            title: '当月协助量',
            width: 90,
            visible: true
          },
          {
            field: 'stockQuantity',
            title: '库存量',
            width: 70
          },
          {
            field: 'realInventoryQty',
            title: '实时库存量',
            width: 80
          },
          {
            field: 'roadQuantity',
            title: '在途量',
            width: 70
          },
          {
            field: 'auditShipmentQuantity',
            title: '已审在发运量',
            width: 100
          },
          {
            field: 'annualInputQty',
            title: '全年投放量',
            width: 100
          },
          {
            field: 'inventoryRate',
            title: '库存率',
            width: 100,
            slots: { default: 'inventoryRate' }
          },

          {
            field: 'remark',
            title: '备注',

            slots: { default: 'remark' }
          }
        ],
        data: [],
        columnsFieldTypes: {
          remark: 'input',
          wantQuantity: 'input',
          baseAuditQuantity: 'input',
          warAuditQuantity: 'input',
          salecenterAuditQuantity: 'input'
        }
      },
      gridOptions3: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 50 },
          {
            field: 'custName',
            title: '开票客户',
            width: 180
          },
          {
            field: 'invoiceDate',
            title: '开票日期',
            width: 120
          },
          {
            field: 'invoId',
            title: '发票号',
            width: 120
          },
          {
            field: 'productText',
            title: '产品名称',
            width: 220
          },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
            width: 110
          },
          {
            field: 'datum',
            title: '占用时间',
            width: 150
          },
          {
            field: 'occupyQty',
            title: '本次占用(件)',
            width: 100
          },
          {
            field: 'zcustomName',
            title: '定制名称',
            width: 80
          }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      },
      gridOptions4:{
        columns: [
          {
            field: 'wantCode',
            title: '要货单号'
          },
          {
            field: 'wantQuantity',
            title: '要货数量',
          },
          {
            field: 'archiveTime',
            title: '归档日期',
          },
          {
            field: 'oneClickStorage',
            title: '是否一键入库'
          },
        ],
        data: []
      }
    }
  },
  computed: {
    isZdzg() {
      return this.wlyApplyForGoodsPo.demandType=='ZDZG'
    },
    isCxj(){
      return this.role.CXJ_ROLE === 'X'
    },
    ...mapGetters(['userInfo', 'role'])
  },
  watch: {
    'wlyApplyForGoodsPo.status': {
      handler(nv) {
        if (nv === 5) {
          this.errorList = ['该单据已被终止！']
        }
      },
      deep: true
    }
  },
  created() {
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
    this.init()
    this.getToGoodsPo()
  },

  methods: {
    // getClientByApp() {
    //   getClientByApp({code: this.userInfo.code}).then(res => {
    //     if(res){
    //       this.panoramaUrl = 'https://yingxiao.wuliangye.com.cn/webroot/login/zdhxLogin_test.html?' + res + '&storeId=' + this.wlyApplyForGoodsPo.terminalId + '&dealerId=' + this.wlyApplyForGoodsPo.customerCode
    //     }
    //   })
    // },
    // jumpPanorama() {
    //   window.open(this.panoramaUrl, '_blank');
    // },
    // 查询在实时库存量
    async thirdRealTimeInventory() {
      try {
        const params = {
          "dealerId": this.wlyApplyForGoodsPo.customerCode,
          "productId": this.wlyApplyForGoodsPo.wantGoodsDetailList[0].productCode,
          "channel": this.wlyApplyForGoodsPo.channelsType,
        }
        const res = await thirdRealTimeInventory(params)
        if (res.status === 2){
          this.gridOptions.data[0].realInventoryQty = 0
        }else{
          this.gridOptions.data[0].realInventoryQty = res.data.inventoryQuantity
        }
      } catch (error) {
      }
    },
    handleRate(row){
      return row.annualInputQty && row.stockQuantity ? (row.stockQuantity/row.annualInputQty* 100).toFixed(2) + '%' : 0
    },
    filterDictionary,
    init() {
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
      // 通知单类型
      this.getSelectDictDataOrigin('A0022')
      // 是否分流
      this.getSelectDictDataOrigin('B0099')
      // 渠道类型
      this.getSelectDictDataOrigin('A0054')
      // 存货分类
      this.getSelectDictDataOrigin('A0019')
      // 要货类型
      this.getSelectDictDataOrigin('A0081')
      // 发货紧急程度
      this.getSelectDictDataOrigin('Significance')
    },
    getLastThreeTimesWantDetail(id){
      findLastThreeTimesWantDetail({ wantCode: id }).then(res => {
        this.gridOptions4.data = res.data
      })
    },
    // 根据id查询发货单信息
    getToGoodsPo() {
      wantgoodsFindById({ id: this.$route.query.id }).then(response => {
        this.wlyApplyForGoodsPo = response.data
        this.wlyApplyForGoodsPo.bizId = response.data.id
        // this.wlyApplyForGoodsPo.taskId = this.$route.query.taskId
        this.wlyApplyForGoodsPo.quotasYear = response.data.quotasYear + ''
        this.wlyApplyForGoodsPo.isShunt = response.data.isShunt + ''
        this.gridOptions.data = this.wlyApplyForGoodsPo.wantGoodsDetailList

        this.gridOptions3.data = this.wlyApplyForGoodsPo.invoiceUsedList
        this.getFiles()
        this.getLastThreeTimesWantDetail(response.data.wantCode)
        // 查询在实时库存量
        this.thirdRealTimeInventory()
        // this.getClientByApp()
        // 基地审批
        if (this.wlyApplyForGoodsPo.subProcUnitId === 'base') {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (v.field === 'baseAuditQuantity') {
              v.visible = true
              v.width = 120
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            this.$set(item, 'baseAuditQuantity', item.wantQuantity)
          })
        }
        if (this.wlyApplyForGoodsPo.subProcUnitId === 'warZone') {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (v.field === 'baseAuditQuantity' || v.field === 'warAuditQuantity') {
              v.visible = true
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            // 如果基地数量为空就取申请数量
            if (!item.baseAuditQuantity) {
              item.baseAuditQuantity = item.wantQuantity
            }
            this.$set(item, 'warAuditQuantity', item.baseAuditQuantity)
          })
        }
        if (['work', 'center'].includes(this.wlyApplyForGoodsPo.subProcUnitId)) {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (
              v.field === 'baseAuditQuantity' ||
              v.field === 'warAuditQuantity' ||
              v.field === 'salecenterAuditQuantity'
            ) {
              v.visible = true
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            // 如果基地数量为空就取申请数量
            if (!item.baseAuditQuantity) {
              item.baseAuditQuantity = item.wantQuantity
            }
            if (!item.warAuditQuantity) {
              item.warAuditQuantity = item.baseAuditQuantity
            }
            this.$set(item, 'salecenterAuditQuantity', item.warAuditQuantity)
          })
        }

        // 如果是渠道类型 是K, 由于审批流程没有战区审批，在内勤审批进入后，把基地审批的数据 赋值给战区协助量
        if (this.wlyApplyForGoodsPo.subProcUnitId === 'work' && (this.wlyApplyForGoodsPo.channelsType === 'K' || this.wlyApplyForGoodsPo.channelsType === 'D')) {
          this.gridOptions.data[0].warAuditQuantity = this.gridOptions.data[0].baseAuditQuantity
        }
        // 渠道类型
        // this.getChannelType()
        this.$refs.xTable.refreshColumn()
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async getFiles() {
      const params = {
        bizId: this.wlyApplyForGoodsPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
    validate(cb) {
      this.errorList = []
      this.$refs['form'].validate((valid, err) => {
        if (valid) {
          try {
            if (!this.wlyApplyForGoodsPo.subProcUnitId) {
              throw new Error('未找到审批节点！subProcUnitId：' + this.wlyApplyForGoodsPo.subProcUnitId)
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'base') {
              this.gridOptions.data.forEach(item => {
                if (item.baseAuditQuantity < 1) {
                  throw new Error('请输入基地协助数量！')
                } else if (item.baseAuditQuantity > item.wantQuantity - 0) {
                  throw new Error('基地协助数量不能大于本次要货数量！')
                }
              })
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'warZone') {
              this.gridOptions.data.forEach(item => {
                if (item.warAuditQuantity < 1) {
                  throw new Error('请输入战区协助数量！')
                } else if (item.warAuditQuantity > item.baseAuditQuantity - 0) {
                  throw new Error('战区协助数量不能大于基地协助数量！')
                }
              })
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'work') {
              this.gridOptions.data.forEach(item => {
                if (item.salecenterAuditQuantity < 1) {
                  throw new Error('请输入销售内勤协助数量！')
                } else if (item.salecenterAuditQuantity > item.warAuditQuantity - 0) {
                  throw new Error('销售内勤协助数量不能大于战区协助数量！')
                }
              })
            }
            cb()
          } catch (e) {
            this.errorList = [e.message]
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    saveData() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.wlyApplyForGoodsPo))
      handlerFlow(params, this.processKey)
        .then(async response => {
          this.loading = false
          if (!this.wlyApplyForGoodsPo.id) {
            this.id = response.data.bizId

            this.wlyApplyForGoodsPo.id = response.data.bizId
            this.wlyApplyForGoodsPo.bizId = response.data.bizId
            this.wlyApplyForGoodsPo.taskId = response.data.taskId
            this.wlyApplyForGoodsPo.procInstId = response.data.bizprocInstId
            this.wlyApplyForGoodsPo.billCode = response.data.bizData.billCode
            this.wlyApplyForGoodsPo.billStatus = response.data.bizData.billStatus
            this.wlyApplyForGoodsPo.createdByName = response.data.bizData.createdByName
            this.gridOptions.data = response.data.bizData.wantGoodsDetailList
          }
          // await advance(this.wlyApplyForGoodsPo)
          this.$message.success('保存成功！')
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
.panorama{
  font-size: 12px;
  color: rgb(45, 146, 214);
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/toGoodsApprove.vue